import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiCompass } from "react-icons/fi";
import { BrandLogo } from "components/ui";

/** Rendered outside Layout (no header/footer), so it carries its own branding. */
export const NotFound = () => {
  return (
    <div className="flex flex-col min-h-screen px-4 bg-canvas sm:px-6">
      <div className="flex items-center justify-center h-[68px]">
        <Link to="/" aria-label="Zamplia Surveys home">
          <BrandLogo className="w-auto h-8" />
        </Link>
      </div>

      <main className="flex items-center justify-center flex-1 py-12">
        <div className="w-full max-w-md p-8 text-center zs-card sm:p-10">
          <span className="inline-flex items-center justify-center w-14 h-14 text-2xl border rounded-lg bg-primary-soft text-primary-text border-primary/15">
            <FiCompass aria-hidden="true" />
          </span>
          <p className="mt-6 text-sm font-semibold tracking-widest tabular-nums text-primary-text">404</p>
          <h2 className="mt-2 text-2xl font-bold tracking-tight font-display text-ink sm:text-3xl">
            404 - Not Found
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink-3">
            The page you are looking for does not exist or may have been moved.
          </p>
          <Link to="/" className="mt-8 zs-btn zs-btn-primary">
            <FiArrowLeft aria-hidden="true" />
            Back to home
          </Link>
        </div>
      </main>
    </div>
  );
};
